import * as React from 'react';
import { observer } from 'mobx-react';
import { styled } from '../../../theme';
import { MigrateAppPayload } from './MigrateAppPage';
import { ButtonType } from '../../../widgets/buttons/ButtonWidget';
import { GroupedButtons } from '../../../widgets/buttons/GroupedButtons';
import { CenterFormOrientation, CenterFormWidget } from '../../../widgets/layout/CenterFormWidget';
import { UnsafeMarkdown } from '../../../widgets/MarkdownWidget';

export interface CreateAppStep3WidgetProps {
  payload: Partial<MigrateAppPayload>;
  updatePayload: (payload: Partial<MigrateAppPayload>) => Promise<void>;
  next: () => Promise<any>;
  back: () => any;
  onCancel: () => any;
}

export const MigrateAppStep3Widget: React.FC<CreateAppStep3WidgetProps> = observer((props) => {
  const getButtons = () => {
    return (
      <GroupedButtons
        btns={[
          {
            label: 'Cancel',
            disabled: props.payload.loading,
            type: ButtonType.TERTIARY,
            action: () => {
              props.onCancel();
            }
          },
          {
            label: 'Back',
            type: ButtonType.SECONDARY,
            disabled: props.payload.loading,
            action: () => {
              props.back();
            }
          },
          {
            label: 'Migrate App',
            action: async (event, loading) => {
              loading(true);
              await props.next();
              loading(false);
            }
          }
        ]}
      />
    );
  };

  return (
    <CenterFormWidget
      noLogo={true}
      primaryLabel={'Migrate app'}
      secondaryLabel={new UnsafeMarkdown(`1) App details > 2) Version control > **3) Confirm**`)}
      orientation={CenterFormOrientation.ROW}>
      <S.Content>
        <h2>Are you sure?</h2>
        <p>Press the button below to migrate the app</p>
      </S.Content>

      <S.Ruler />
      {getButtons()}
    </CenterFormWidget>
  );
});

const BASE_LABEL = 'migrate-app-step-3';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    max-width: 386px;
  `;

  export const Content = styled.div`
    font-weight: 300;
    margin-bottom: 20px;
    color: ${(p) => p.theme.text.primary};

    h1,
    h2,
    h3,
    p {
      margin-bottom: 10px;
    }
  `;

  export const Ruler = styled.div`
    label: ${BASE_LABEL}__ruler;
    height: 1px;
    background: ${(p) => p.theme.forms.ruler};
    margin-top: 32px;
    margin-bottom: 32px;
  `;
}
